import { BASE_URL, MOBILE_BASE_URL } from "../api_const"

export const PROJECT_ENQ_REQ_BASE_URL = BASE_URL + "/project_enquiry"
